// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 225) return "7.0.32372-225.min.js";
	if (chunkId === 193) return "7.0.32372-193.min.js";
	if (chunkId === 279) return "7.0.32372-account-summary.min.js";
	if (chunkId === 378) return "7.0.32372-verify-account.min.js";
	if (chunkId === 167) return "7.0.32372-account-comments.min.js";
	// return url for filenames based on template
	return undefined;
};